import {
  DEFAULT_CALL_ANSWER_TIMEOUT_SEC,
  DEFAULT_INTERPRETING_TIMER_SEC,
  DEFAULT_MAX_CONSECUTIVE_ANSWER_TO,
  DEFAULT_SERVICE_UNREGISTERED_HEARING_TO_DEAF_CALLS,
  DEFAULT_SESSION_UPDATE_TIMER_SEC,
  DEFAULT_TRAINING_FORKER_ACTIVE_LANGUAGES,
} from 'features/app-config/constants';
import type { AppConfig, Languages } from 'features/app-config/interfaces';

export class AppConfigService {
  private static appConfig: AppConfig = {} as AppConfig;

  public static setAppConfig(config: AppConfig) {
    this.appConfig = config;
  }

  private static getConfigValue(key: keyof AppConfig) {
    const value = this.appConfig[key];
    return value;
  }

  public static get callAnswerTimeout() {
    return (
      Number(this.getConfigValue('CallAnswerTimeoutSeconds')) ||
      DEFAULT_CALL_ANSWER_TIMEOUT_SEC
    );
  }

  public static get defaultOutboundCallerIdEnglish(): string {
    const value = this.getConfigValue('DefaultOutboundCallerId_English');

    if (typeof value === 'string' && value.length > 0) {
      return value;
    }

    return '8663278877';
  }

  public static get defaultOutboundCallerIdSpanish(): string {
    const value = this.getConfigValue('DefaultOutboundCallerId_Spanish');

    if (typeof value === 'string' && value.length > 0) {
      return value;
    }

    return '8669877528';
  }

  public static get maxConsecutiveAnswerTO() {
    return (
      Number(this.getConfigValue('MaxConsecutiveAnswerTO')) ||
      DEFAULT_MAX_CONSECUTIVE_ANSWER_TO
    );
  }

  public static get suicidePreventionNumber(): string {
    const value = this.getConfigValue('SuicidePreventionConnectionString');
    if (typeof value === 'string' && value?.length > 0) {
      return value;
    }
    return '8002738255';
  }

  public static get autoUpdateSessionActivityTime() {
    return (
      Number(this.getConfigValue('SessionUpdateTimerSeconds')) ||
      DEFAULT_SESSION_UPDATE_TIMER_SEC
    );
  }

  public static get interpretingTimerSeconds() {
    return (
      Number(this.getConfigValue('InterpretingTimerSeconds')) ||
      DEFAULT_INTERPRETING_TIMER_SEC
    );
  }

  public static get activeLanguages(): Languages[] {
    return (this.getConfigValue('ActiveLanguages') as Languages[]) || [];
  }

  public static get trainingForkerActiveLanguages(): string[] {
    const value = this.getConfigValue('TrainingForkerActiveLanguages');

    if (!Array.isArray(value) || value.length === 0) {
      return DEFAULT_TRAINING_FORKER_ACTIVE_LANGUAGES;
    }

    const normalized = value
      .map((language) =>
        typeof language === 'string' ? language.trim().toUpperCase() : ''
      )
      .filter(Boolean);

    return normalized.length > 0
      ? normalized
      : DEFAULT_TRAINING_FORKER_ACTIVE_LANGUAGES;
  }

  public static get isCheckOnRegistrationNeed() {
    //Returns a boolean value instead of "TRUE" or "FALSE"
    return (
      !JSON.parse(
        String(
          this.getConfigValue('ServiceUnregisteredHearingToDeafCalls')
        ).toLocaleLowerCase()
      ) || DEFAULT_SERVICE_UNREGISTERED_HEARING_TO_DEAF_CALLS
    );
  }
  public static get parkedCallNotificationConfig() {
    return {
      alertSeconds: Number(this.getConfigValue('ParkedCallAlertSeconds')) || 60,
      chimeIntervalSeconds:
        Number(this.getConfigValue('ParkedCallChimeIntervalSeconds')) || 15,
    };
  }

  public static get abandonedHearingCallTimerSeconds() {
    return Number(this.getConfigValue('AbandonedHearingCallTimerSeconds')) || 0;
  }
}
